import { render, staticRenderFns } from "./modal-platform-link.vue?vue&type=template&id=41ee6080&scoped=true"
import script from "./modal-platform-link.vue?vue&type=script&lang=js"
export * from "./modal-platform-link.vue?vue&type=script&lang=js"
import style0 from "./modal-platform-link.vue?vue&type=style&index=0&id=41ee6080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ee6080",
  null
  
)

export default component.exports